<accordion [closeOthers]="true">
  <accordion-group heading="Administration">
    <ul class="list-group list-group-flush small">
      <li class="list-group-item"><a routerLink="/hhgratefiling" routerLinkActive="active">HHG Rate
        Filing</a></li>
      <li class="list-group-item"><a routerLink="/hhgrateedit" routerLinkActive="active">HHG Rate
        Edit</a></li>
      <li class="list-group-item"><a routerLink="/agencytspsearch" routerLinkActive="active">User
        Profile</a></li>
    </ul>
  </accordion-group>
  <accordion-group heading="Group 2">
    <ul class="list-group list-group-flush small">
      <li class="list-group-item"><a href="">Link 1</a></li>
      <li class="list-group-item"><a href="">Link 2</a></li>
    </ul>
  </accordion-group>
</accordion>
